import React from 'react';
import BaseCreatePage from '../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import * as instructionToQuoteCrud from '../../../../crud/instructionToQuote.crud';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import { FormattedMessage } from "react-intl";
import moment from 'moment';
import { withCreatePageProps } from '../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../shared/common';
import { actionCodes } from "../../../../shared/lookup";

class ItqCreatePage extends BaseCreatePage {
    constructor(props) {
        super(props);
        this.createDefaultSubject = (((props.location || {}).state || {}).itemCustomProps || {}).subject;
        this.createDefaultAsset = (((props.location || {}).state || {}).itemCustomProps || {}).assetid;

        this.state = {
            showAlert: true,
        };
    }

    submitHandler = (itq, setSubmitting) => {
        const postEvents = (createdid) => {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
            this.props.navigate(this.props.workflowItem.paths.basePath + createdid);
        };

        const { companyid, projectid, contractid } = this.props.contract;
        
        itq.companyid = companyid;
        itq.contractid = contractid;
        itq.projectid = projectid;

        if (itq.startdate) {
            itq.startdatedisplay = moment(itq.startdate).format('DD/MM/YYYY');
        }

        if (itq.completiondate) {
            itq.completiondatedisplay = moment(itq.completiondate).format('DD/MM/YYYY');
        }

        itq.status = 'Not Communicated';
        itq.showtasknotification = 0;
        itq.actioncode = actionCodes.CREATE;
        itq.workflowid = this.props.workflowItem.id;
        this.appendRelationship(itq);
        Common.PropertyConversionsBeforeNoticeSaveRequest(itq, this.props.customFields, this.props.contractUsers);
        instructionToQuoteCrud.createInstructionToQuote(itq)
            .then(response => {
                const createdID = Number(response.data);
                postEvents(createdID);
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }

    render() {
        const { fields } = this.props.workflowItem;
        const createFormConfig = {
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };

        if (fields.Subject.visible) {
            createFormConfig.fields.push({ label: fields.Subject.label, dataField: 'subject', editorOptions: { defaultValue: this.createDefaultSubject } });
        }
        createFormConfig.fields.push({ note: this.props.resources.InstructionToQuoteNote.replace('$date', moment().add(this.props.globalResources.ITQ_QUOTE_DURATION, 'days').format('L')) });
        if (fields.Description.visible) {
            createFormConfig.fields.push({ label: fields.Description.label, dataField: 'description', editorType: 'dxHtmlEditor' });
        }

        if (fields.StartDate.visible) {
            createFormConfig.fields.push({ label: fields.StartDate.label, dataField: 'startdate', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } })
        }
        if (fields.CompletionDate.visible) {
            const completionDateField = { label: fields.CompletionDate.label, dataField: 'completiondate', editorType: 'dxDateBox', validation: { type: 'range', min: new Date(1900, 0, 1), max: new Date(2079, 5, 6), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } }

            if (fields.StartDate.visible) {
                completionDateField.validation = { type: 'custom', validationCallback: (obj, value) => (obj.startdate <= value), warning: 'Completion date can not be earlier than start date' };
            }
            createFormConfig.fields.push(completionDateField);
        }
        if (fields.DelayAmount.visible) {
            createFormConfig.fields.push({ label: fields.DelayAmount.label, dataField: 'delaydamagestotal', editorType: 'dxNumberBox' })
        }
        if (fields.DelayPaymentPeriod.visible) {
            createFormConfig.fields.push({ label: fields.DelayPaymentPeriod.label, dataField: 'delaydamagestype', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.DelayPaymentPeriod.paymentPeriods } })
        }

        return (
            <Portlet>
                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1000 }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                            </p>
                        </Alert>
                    )}
                    {this.props.resources.PmInstructionToQuoteWarningBanner && (
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.PmInstructionToQuoteWarningBanner}
                            </p>
                        </Alert>
                    )}
                    <BiDynamicForm
                        onSubmitHandler={this.submitHandler}
                        config={createFormConfig}
                        valueChangeHandler={this.onValueChanged}
                        customFields={(this.props.customFields || {}).COMMUNICATION}
                        assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                        assetid={this.createDefaultAsset}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users
});

export default withCreatePageProps(connect(mapStateToProps)(ItqCreatePage));
